import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/customer-mono/customer-mono/companion-auth/src/app/(auth)/forgot-password/request-email/requestEmailClient.tsx");
